var map = {
	"./icon_market_binance.png": 2472,
	"./icon_market_gate.png": 22910,
	"./icon_market_huobi.png": 53083,
	"./icon_market_kraken.png": 17997,
	"./icon_market_kucoin.png": 18552,
	"./icon_market_okex.png": 89711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99723;